import type { CSSProperties, ReactNode } from 'react'
import { cx } from './cx.js'

// ── type ──────────────────────────────────────────────────────────────────
export function H({
  children,
  className,
  style,
}: {
  children: ReactNode
  className?: string
  style?: CSSProperties
}) {
  return (
    <h2 className={cx('fm-h', className)} style={style}>
      {children}
    </h2>
  )
}
export function Label({
  children,
  htmlFor,
  className,
}: {
  children: ReactNode
  htmlFor?: string
  className?: string
}) {
  return (
    <label htmlFor={htmlFor} className={cx('fm-label', className)}>
      {children}
    </label>
  )
}
export function P({
  children,
  muted,
  sm,
  className,
  style,
}: {
  children: ReactNode
  muted?: boolean
  sm?: boolean
  className?: string
  style?: CSSProperties
}) {
  return (
    <p className={cx('fm-p', muted && 'fm-muted', sm && 'fm-sm', className)} style={style}>
      {children}
    </p>
  )
}
